import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'

Vue.use(Vuetify)

var d = new Date();
var h = d.getHours();

const opts = {
  theme: {
    dark: h < 10 ? false : true,
  },
  icons: {
    iconfont: 'mdi' || 'md'
  }
 
}

export default new Vuetify(opts)